export class Libro {
  id!: number;
  isbn?: string;
  titolo?: string;
  autore?: string;
  editore?: string;
  anno?: number;
  collocazione?: string;
  note?: string;
  deleted?: boolean;
  inprestito?: boolean;
  cover?: string;
}

export class LibriSearchRequest {
  titolo?: string;
  autore?: string;
  editore?: string;
  anno?: number;
  collocazione?: string;
  isbn?: string;
}

export class CountResponseWeb {
  cnt!: number;
}
